<!--  -->
<template>
  <div class="fxqy">
      <div class="head">风险区域</div>
      <div class="close" @click="close">x</div>
      <div class="content">
          <div class="item" style="width:29%">
              <div style="margin-left:10px;margin-top:5px">区域名称</div>
              <div style="margin-left:10px;margin-top:15px;">K1-K6</div>
          </div>
          <div class="item" style="width:35%">
              <div style="margin-top:5px;text-align: center;">风险等级</div>
              <div style="margin-top:15px;text-align: center;color:#d11717;">3</div>
          </div>
          <div class="item">
              <div style="margin-top:5px;text-align: center;">等级变化</div>
              <div style="margin-top:15px;text-align: center;color:#eeff5f;">无</div>
          </div>
      </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  components: {},

  computed: {},

  methods: {
      close(){
          this.$emit("close");
      }
  }
};
</script>
<style lang="less" scoped>
.fxqy {
  width: 316px;
  height: 124px;
  position: absolute;
  top: 20vh;
  left: 20vw;
  background: url("../assets/tc.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .close{
    position: absolute;
      color: #bcdeff;
      right: 15px;
      top: 5px;
      cursor: pointer;
  }
  .head{
      height: 36%;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #bcdeff;
      font-size: 12px;
  }
  .content{
      display: flex;
      height: 47%;
      margin-left: 10%;
      .item{
          font-size: 12px;
          color: #bcdeff;
          width: 32%;
          .btn{
              width: 64px;
              height: 21px;
              background: url(../assets/btn2.png);
              background-repeat: no-repeat;
              background-size: 100% 100%;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-left: 16px;
          }
      }
  }
}
</style>